import React, { useState } from 'react';
import { makeStyles, Button } from '@fluentui/react-components';
import { ArrowUpload20Regular } from '@fluentui/react-icons';
import { FileUploadQuestion as FileUploadQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#333333',
    marginBottom: '0px',
  },
  uploadArea: {
    paddingLeft: '0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  uploadButton: {
    width: 'fit-content',
    height: '32px',
    fontSize: '14px',
  },
  fileInfo: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '12px',
    color: '#605e5c',
    lineHeight: '16px',
  },
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    color: '#242424',
  },
});

interface FileUploadQuestionViewProps {
  question: FileUploadQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const FileUploadQuestionView: React.FC<FileUploadQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();
  const [files, setFiles] = useState<string[]>([]);

  const handleFileUpload = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Simulated file upload - in real implementation would use input[type=file]
    setFiles([...files, `File ${files.length + 1}.pdf`]);
  };

  return (
    <div 
      className={styles.container}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      data-question-view
    >
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.uploadArea}>
        <Button
          className={styles.uploadButton}
          appearance="secondary"
          icon={<ArrowUpload20Regular />}
          onClick={handleFileUpload}
        >
          Upload file
        </Button>
        
        <div className={styles.fileInfo}>
          File number limit: {question.maxFiles || 1} &nbsp; Single file size limit: {question.maxSize || 10}MB &nbsp; Allowed file types: {question.allowedTypes?.join(', ') || 'Word, Excel, PPT, PDF, Image, Video, Audio'}
        </div>
        
        {files.length > 0 && (
          <div className={styles.fileList}>
            {files.map((file, index) => (
              <div key={index} className={styles.fileItem}>
                {file}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
